interface AppealIconProps {
  /** Stroke color; white when selected, #999999 when inactive. */
  strokeColor?: string;
}

/**
 * Outline appeal icon for header navigation tabs.
 *
 * @param strokeColor - Icon stroke color (defaults to #999999 for inactive state)
 */
const AppealIcon = ({ strokeColor = "#999999" }: AppealIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 16 15"
      fill="none"
    >
      <path
        d="M9.39361 4.20139H13.3628C13.6775 4.20139 13.8349 4.20139 13.927 4.26343C14.0073 4.31756 14.0596 4.40088 14.071 4.49298C14.0842 4.59854 14.0078 4.72752 13.8549 4.98548L12.9076 6.58397C12.8522 6.67752 12.8245 6.72429 12.8136 6.77383C12.804 6.81767 12.804 6.86289 12.8136 6.90673C12.8245 6.95626 12.8522 7.00304 12.9076 7.09659L13.8549 8.69508C14.0077 8.95303 14.0842 9.08201 14.071 9.18757C14.0596 9.27967 14.0073 9.36299 13.927 9.41713C13.8349 9.47917 13.6775 9.47917 13.3628 9.47917H8.40842C8.01431 9.47917 7.81725 9.47917 7.66672 9.40726C7.53431 9.34401 7.42666 9.24309 7.35919 9.11895C7.28249 8.97783 7.28249 8.79309 7.28249 8.42361V6.84028M4.81953 13.4375L2.00472 2.88194M3.0603 6.84028H8.26768C8.66179 6.84028 8.85885 6.84028 9.00938 6.76837C9.14179 6.70512 9.24944 6.6042 9.31691 6.48006C9.3936 6.33894 9.3936 6.1542 9.3936 5.78472V2.61806C9.3936 2.24858 9.3936 2.06384 9.31691 1.92271C9.24944 1.79858 9.14179 1.69766 9.00938 1.63441C8.85885 1.5625 8.66179 1.5625 8.26768 1.5625H3.09491C2.60336 1.5625 2.35759 1.5625 2.18948 1.65799C2.04215 1.74167 1.93268 1.87312 1.88181 2.02742C1.82377 2.20347 1.88338 2.42701 2.00261 2.87408L3.0603 6.84028Z"
        stroke={strokeColor}
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AppealIcon;
